import React, {useEffect, useState} from "react";
import {Field, useForm, useFormState} from "react-final-form";
import DeadlineDatepickerModal from "../modals/DeadlineDatepickerModal";
import {getDateRange, getMatchOptionInterval} from "../../helpers/DateHelper";
import dayjs from "dayjs";
import OutsideClickHandler from "react-outside-click-handler";

function DeadlineDatepickerField({name, exactName, deadlines, numberOfMonths}) {
    const form = useForm();
    const exactDeadlineValue = useFormState().values[exactName];

    const [showModal, setShowModal] = useState(false);
    const [deadlineString, setDeadlineString] = useState('');
    const [estimatedDeadline, setEstimatedDeadline] = useState('');

    useEffect(() => {
        updateDeadlineString();
        updateEstimatedDeadline();
    }, [exactDeadlineValue])

    const updateDeadlineString = () => {
        let result = '';

        const hours = parseInt(exactDeadlineValue / 3600);
        const days = parseInt(exactDeadlineValue / (3600 * 24));

        const {dateTo} = getDateRange(exactDeadlineValue);

        result = hours > 24 ? days+' days' : hours+' hours';
        result+= dayjs(dateTo).format(' / ddd, MMM D/ hh:mm A');

        setDeadlineString(result)
    }

    const updateEstimatedDeadline = () => {
        const {dateTo} = getDateRange(exactDeadlineValue);

        setEstimatedDeadline(dayjs(dateTo).format('dddd, h A'))
    }

    const handleShowModal = () => {
        setShowModal(true);
    }

    const handleCancelModal = () => {
        setShowModal(false);
    }

    const handleApplyDeadline = exactInterval => {
        const interval = getMatchOptionInterval(exactInterval, deadlines);

        form.change(name, interval);
        form.change(exactName, exactInterval);
    }

    return <div className="datepicker__container form-date-picker">
        <div className="date-picker date-picker-single" onClick={handleShowModal}>
            <div className="daterange-single">{deadlineString}</div>
            <Field name={name} component="input" type="hidden" />
            <Field name={exactName} component="input" type="hidden" />
        </div>
        <div className="form-group-info">Approximate deadline: {estimatedDeadline}</div>
        {showModal && (
            <OutsideClickHandler onOutsideClick={handleCancelModal}>
                <DeadlineDatepickerModal
                    exactDeadline={exactDeadlineValue}
                    setExactDeadline={handleApplyDeadline}
                    cancelModal={handleCancelModal}
                    deadlines={deadlines}
                    numberOfMonths={numberOfMonths}
                />
            </OutsideClickHandler>
        )}
    </div>
}

export default DeadlineDatepickerField;